/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment.prod';

export const LOCAL_LANGUAGE_KEY = "ADV_lang"

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(private translateService: TranslateService) { }

  ngOnInit() {

    if (!environment.production) {
      console.log(environment.endpoint);
    }

    // Linguaggi supportati dall'applicazione
    this.translateService.addLangs(['it', 'en'])
    /*
     Lingua di fallback in caso di traduzione non presente 
     per la lingua corrente
    */
    this.translateService.setDefaultLang('it');

    const browserLang = this.translateService.getBrowserLang()
    const availableLangs = this.translateService.getLangs()
    const preferredLang = localStorage.getItem(LOCAL_LANGUAGE_KEY)
    /**
     * Criterio di selezione lingua dell'applicazione:
     * - si verifica se l'utente ha gia' selezionato una lingua salvata nel local storage
     * - altrimenti si verifica se la lingua del browser e' tra quelle supportate dall'applicazione
     * - altrimenti fallback in italiano 
     */
    if (preferredLang) {
      this.translateService.use(preferredLang)
    }
    else if (availableLangs.includes(browserLang)) {
      this.translateService.use(browserLang)
    }
    else {
      this.translateService.use('it')
    }
  }
  
}

